import { useParams } from "react-router-dom";
import PageVille, { PREFIXE_VILLE } from "./PageVille";
import PageService from "./PageService";
import { trouverService } from "@/data/services-pages";
import NotFound from "@/pages/NotFound";

/**
 * Un seul segment dynamique vit sous /services, donc un seul composant le
 * recoit. React Router 6 ne sait pas distinguer deux routes qui ont la meme
 * forme, l'arbitrage se fait donc ici, sur le slug.
 *
 * Trois issues : le prefixe des villes rend la page ville, un slug connu du
 * catalogue de services rend la page service, le reste tombe sur le vrai 404
 * du site, qui est le seul a poser le noindex. Sans cette derniere branche,
 * n'importe quel slug invente deviendrait un soft 404 indexable.
 */
const AiguilleurServices = () => {
  const { page = "" } = useParams();

  if (page.startsWith(PREFIXE_VILLE)) return <PageVille />;
  if (trouverService(page)) return <PageService />;
  return <NotFound />;
};

export default AiguilleurServices;
